import { Component, OnDestroy, inject, ChangeDetectorRef } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SvgIconComponent } from '../../ui/svg-icon/svg-icon.component';
import { Subject } from 'rxjs';
import { SnackbarData } from '../../models/snackbar';

@Component({
  selector: 'app-snackbar',
  imports: [SvgIconComponent],
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent implements OnDestroy {
  snackBarRef = inject<MatSnackBarRef<SnackbarComponent>>(MatSnackBarRef);
  data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);
  private readonly cdr = inject(ChangeDetectorRef);

  public messages: string[];
  duration: number | null;
  remainingSeconds: number | null;
  countdownInterval: any;

  destroy$ = new Subject<void>();

  constructor() {
    const snackBarRef = this.snackBarRef;
    const data = this.data;

    this.messages = Array.isArray(data.messages) ? data.messages : [data.messages];
    this.duration = snackBarRef.containerInstance.snackBarConfig?.duration ?? null;

    // Only calculate remainingSeconds/countdown if duration is a finite number
    if (typeof this.duration === 'number' && isFinite(this.duration) && this.duration > 0) {
      this.remainingSeconds = Math.ceil(this.duration / 1000);
      this.countdownInterval = setInterval(() => {
        if (this.remainingSeconds !== null) {
          this.remainingSeconds--;
          if (this.remainingSeconds <= 0) {
            clearInterval(this.countdownInterval);
          }
        }
        this.cdr.markForCheck();
      }, 1000);
    } else {
      this.remainingSeconds = null;
    }
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success':
        return 'check-circle';
      case 'error':
        return 'close-circle';
      case 'info':
        return 'info-cc';
      case 'warning':
        return 'warning-cc';
      default:
        return 'info-cc';
    }
  }

  close(): void {
    this.snackBarRef.dismiss();
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
